import FingerRun from "../components/games/FingerRun/FingerRun";
import NumberJungle from "../components/games/NumberJungle/NumberJungle";
import PenAcrobatics from "../components/games/PenAcrobatics/PenAcrobatics";
import Crossword from "../components/games/Crossword/Crossword";
import Scramble from "../components/games/Scramble/Scramble";
import ArmsUp from "../components/games/ArmsUp/ArmsUp";
import FingerSkills from "../components/games/FingerSkills/FingerSkills";
import CatchTheBall from "../components/games/CatchTheBall";
import RememberSymbols from "../components/games/RememberSymbols/RememberSymbols";
import OnPosition from "../components/games/OnPosition/OnPosition";

export default [
  {
    name: "catchtheball",
    color: "#E11B0A",
    levels: 4,
    training: `
    Hier trainieren Sie Ihre
    Auge-Hand-Koordination und
    das räumliche
    Vorstellungs-vermögen. Sie
    müssen die Flugbahn des Balles
    quasi vorausberechnen. Das
    macht fit für ähnliche
    Situationen im Alltag. Bei Stufe
    3 fordert die spiegelverkehrte
    Bewegung des Korbes
    zusätzlich das Zusammenspiel
    von linker und rechter
    Hirnhälfte.
    `,
    instruction:
      "Klicken Sie auf »Start«. Greifen Sie dann die Korb-Markierung mit der Maus. Schieben Sie den Korb mit gedrückter linker Maustaste auf der Schiene hin und her, um die Bälle zu fangen.",
    overwriteInstructionAtLevel: {
      3: "Klicken Sie auf »Start«. Greifen Sie dann die Korb-Markierung mit der Maus. Schieben Sie den Korb mit gedrückter linker Maustaste auf der Schiene hin und her, um die Bälle zu fangen. Achtung: Der Korb bewegt sich gegenläufig, das heißt nach rechts, wenn Sie die Maus nach links schieben und umgekehrt!",
    },
    component: CatchTheBall,
  },
  {
    name: "remember",
    color: "#E5743A",
    levels: 1,
    training: `
    Hier steht die Merkspanne im
Mittelpunkt. Eben Geschehenes
ist oft schon nach Sekunden
nicht mehr präsent. Eine
Steigerung um 1 Symbol nach
regelmäßigem Üben macht sich
im Alltag extrem positiv
bemerkbar. Bei der Abfrage ist
zusätzlich zur Merkspanne eine
schnelle

Informations-Verarbeitung
gefordert.`,
    instruction: `
    Nachdem Sie auf »Start« geklickt haben, sehen Sie 4 Symbole im Abstand von
jeweils 1 Sekunde. Klicken Sie sofort anschließend auf »Abfrage starten«.
Markieren Sie dann zügig die Symbole in der Auswahl. Ihre Entscheidungen
werden nur dann als richtig angezeigt, wenn Sie die bei der Präsentation
vorgegebene Reihenfolge exakt einhalten. Für diese Aufgabe steht Ihnen nur
begrenzt Zeit zur Verfügung. Sie müssen sich schnell entscheiden.

Führen Sie die Übung nicht zu häufig nacheinander durch. 2-3 Durchgänge
genügen meist. Andernfalls fällt das Löschen der vorherigen Informationen schwer.`,
    overwriteInstructionAtLevel: {
      2: `Nachdem Sie auf »Start« geklickt haben, sehen Sie 5 Symbole im Abstand von
  jeweils 1 Sekunde. Klicken Sie sofort anschließend auf »Abfrage starten«.
  Markieren Sie dann zügig die Symbole in der Auswahl. Ihre Entscheidungen
  werden nur dann als richtig angezeigt, wenn Sie die bei der Präsentation
  vorgegebene Reihenfolge exakt einhalten. Für diese Aufgabe steht Ihnen nur
  begrenzt Zeit zur Verfügung. Sie müssen sich schnell entscheiden.
  
  Führen Sie die Übung nicht zu häufig nacheinander durch. 2-3 Durchgänge
  genügen meist. Andernfalls fällt das Löschen der vorherigen Informationen schwer.`,
      3: `    Nachdem Sie auf »Start« geklickt haben, sehen Sie 6 Symbole im Abstand von
  jeweils 1 Sekunde. Klicken Sie sofort anschließend auf »Abfrage starten«.
  Markieren Sie dann zügig die Symbole in der Auswahl. Ihre Entscheidungen
  werden nur dann als richtig angezeigt, wenn Sie die bei der Präsentation
  vorgegebene Reihenfolge exakt einhalten. Für diese Aufgabe steht Ihnen nur
  begrenzt Zeit zur Verfügung. Sie müssen sich schnell entscheiden.
  
  Führen Sie die Übung nicht zu häufig nacheinander durch. 2-3 Durchgänge
  genügen meist. Andernfalls fällt das Löschen der vorherigen Informationen schwer.`,
      4: `    Nachdem Sie auf »Start« geklickt haben, sehen Sie 7 Symbole im Abstand von
  jeweils 1 Sekunde. Klicken Sie sofort anschließend auf »Abfrage starten«.
  Markieren Sie dann zügig die Symbole in der Auswahl. Ihre Entscheidungen
  werden nur dann als richtig angezeigt, wenn Sie die bei der Präsentation
  vorgegebene Reihenfolge exakt einhalten. Für diese Aufgabe steht Ihnen nur
  begrenzt Zeit zur Verfügung. Sie müssen sich schnell entscheiden.
  
  Führen Sie die Übung nicht zu häufig nacheinander durch. 2-3 Durchgänge
  genügen meist. Andernfalls fällt das Löschen der vorherigen Informationen schwer.`,
    },
    component: RememberSymbols,
  },
  {
    name: "fingerlauf",
    color: "#ED9522",
    levels: 1,
    component: FingerRun,
    training: `Das Bewegen der Finger führt
    zu einer vermehrten
    Durchblutung Ihres Gehirns.
    Bei dieser Übung ist die
    Wirkung noch dadurch
    intensiviert, dass Sie
    gleichzeitig denken - nämlich
    die Buchstaben finden und
    zuordnen - müssen.`,
    overwriteInstructionAtLevel: {
      2: `Legen Sie beide Hände flach auf den Tisch mit den Handflächen nach oben. Belegen Sie in Gedanken Ihre Finger mit den Buchstaben, die Sie auf den hier abgebildeten Hénden sehen. »Schreiben« Sie nun das angezeigte Wort, indem Sie mögllchst zügig nacheinander die entsprechenden Finger kurz anheben und wieder ablegen. Sie dürfen die Angaben auf dem Bildschirm dabei immer betrachten. Beim Wort >>SPORT<< heben also schnell hintereinander die folgenden Finger: rechter kleiner Finger, rechter Mittelfinger, linker Daumen, linker Ringfinger, linker Mittelfinger. Klicken Sie anschlieBend auf den Knopf »Neuer Begriff<< und verfahren Sie genauso.`,
      3: `Legen Sie beide Hände mit überkreuzten Armen flach auf den Tisch mit den Handrücken nach oben. Belegen Sie in Gedanken Ihre Finger mit den Buchstaben, die Sie auf den hier abgebildeten Hénden sehen. »Schreiben« Sie nun das angezeigte Wort, indem Sie mögllchst zügig nacheinander die entsprechenden Finger kurz anheben und wieder ablegen. Sie dürfen die Angaben auf dem Bildschirm dabei immer betrachten. Beim Wort >>SPORT<< heben also schnell hintereinander die folgenden Finger: rechter kleiner Finger, rechter Mittelfinger, linker Daumen, linker Ringfinger, linker Mittelfinger. Klicken Sie anschlieBend auf den Knopf »Neuer Begriff<< und verfahren Sie genauso.`,
    },
    instruction: `Legen Sie beide Hände flach auf den Tisch mit den Handrücken nach oben. Belegen Sie in Gedanken Ihre Finger mit den Buchstaben, die Sie auf den hier abgebildeten Händen sehen. »Schreiben« Sie nun das angezeigte Wort, indem Sie mögllchst zügig nacheinander die entsprechenden Finger kurz anheben und wieder ablegen. Sie dürfen die Angaben auf dem Bildschirm dabei immer betrachten. Beim Wort >>SPORT<< heben also schnell hintereinander die folgenden Finger: rechter kleiner Finger, rechter Mittelfinger, linker Daumen, linker Ringfinger, linker Mittelfinger. Klicken Sie anschlieBend auf den Knopf »Neuer Begrlff<< und verfahren Sie genauso.`,
  },
  {
    name: "numberjungle",
    color: "#FBC830",
    levels: 1,
    component: NumberJungle,
    training: `Mit dieser Übung machen Sie
    Ihren Kurzspeicher fit. Sie
    trainieren damit die
    Informations-Verarbeitungs-Geschwindigkeit und die
    Merkspanne. Sie müssen in
    dem Durcheinander schnell eine
    bestimmte Zahl finden und sich
    möglichst schon die Positionen
    einiger Zahlen, die Ihnen beim
    Suchen "begegnen" im Voraus
    merken. Die verschiedenen
    Farben sorgen zusätzlich für
    Verwirrung des Gehirns.`,
    instruction: `Suchen Sie die Zahlen von 1 bis 50 in aufsteigender Reihenfolge und klicken
    Sie sie an, das heißt zuerst die 1, dann die 2 usw. bis zur 50.
    
    Die richtig angeklickten Zahlen verschwinden. Gehen Sie möglichst
    zügig vor!`,
    overwriteInstructionAtLevel: {
      2: `Suchen Sie die Zahlen von 50 bis 1 in absteigender Reihenfolge und klicken Sie
    sie an, das heißt zuerst die 50, dann die 49 usw. bis zur 1
    
    Die bereits richtig angeklickten Zahlen bleiben unverändert stehen. Gehen Sie
    möglichst zügig vor!
    `,
      3: `Suchen und klicken Sie nacheinander die 50 Zahlen an. Die Reihenfolge, in der
    Sie suchen sollen, wird Ihnen angezeigt.
    
    Sobald Sie eine Zahl angeklickt haben, erscheint auf dem
    Bildschirm die Information, welche Zahl Sie als nächste suchen und anklicken
    sollen. Bereits angeklickte Zahlen bleiben unverändert erhalten.
    `,
    },
  },
  {
    name: "onposition",
    color: "#EEE400",
    levels: 1,
    training: `Bei dieser Übung geht es
    vorrangig um Ihre Merkspanne.
    Dabei handelt es sich um den
    Zeitraum, in dem soeben
    aufgenommene Informationen
    aus dem Kurzspeicher direkt
    abrufbar bleiben. Im
    Kurzspeicher können
    Informationen ca. 5 bis 7, aber
    maximal 9 Sekunden bewusst gehalten
    werden. Die Merkspanne
    unterliegt keiner
    altersbedingten Veränderung!
    Sie kann durch gezieltes Üben
    bis ins hohe Alter erhalten und
sogar gesteigert werden.
Die Auswahl der Elemente
steigert bewusst beide
Hirnhälften (Hemisphären) an -
Zahlen und Buchstaben mehr

die linke, Symbole und Farben
mehr die rechte.`,
    instruction: `Es wird jeweils für einige Sekunden eine Spielkarte eingeblendet, die in fünf Felder
    aufgeteilt ist. Die Felder enthalten Informationen - Zahlen, Buchstaben, Silben,
    Symbole und Farbkreise, alle in verschiedenen Farben.
    
    Schauen Sie sich die Karte genau an und merken Sie sich möglichst die Position
    der einzelnen Informationen.
    
    Sobald die vollständige Karte verschwindet, sehen Sie eine leere Karte mit
    Feldeinteilung und die einzelnen Elemente, durcheinander angeordnet. Ziehen Sie
    mit der Maus die Elemente an ihre richtigen Positionen.
    
    Klicken Sie auf Neue Spielkarte für das nächste Spiel.`,
    component: OnPosition,

    overwriteInstructionAtLevel: {
      2: `Es wird jeweils für einige Sekunden eine Spielkarte eingeblendet, die in fünf Felder
    aufgeteilt ist. Die Felder enthalten Informationen - Zahlen, Buchstaben, Silben,
    Symbole und Farbkreise, alle in verschiedenen Farben. Schauen Sie sich die Karte
    genau an und merken Sie sich möglichst die Position der einzelnen Informationen.
    Sobald die vollständige Karte verschwindet, sehen Sie eine leere Karte mit
    Feldeinteilung und die einzelnen Elemente, durcheinander angeordnet.
    
    Achtung! Es sind mehr Elemente im Umlauf als auf der Karte abgebildet waren.
    Ziehen Sie mit der Maus die Elemente an ihre richtigen Positionen. Klicken Sie auf
    Neue Spielkarte für das nächste Spiel.
    `,
      3: `Es wird jeweils für einige Sekunden eine Spielkarte eingeblendet, die in fünf Felder
    aufgeteilt ist. Die Felder enthalten Informationen - Zahlen, Buchstaben, Silben,
    Symbole und Farbkreise, alle in verschiedenen Farben. Schauen Sie sich die Karte
    genau an und merken Sie sich möglichst die Position der einzelnen Informationen.
    Sobald die vollständige Karte verschwindet, sehen Sie eine leere Karte mit
    Feldeinteilung und die einzelnen Elemente, durcheinander angeordnet.
    
    Achtung! Es sind mehr Elemente im Umlauf als auf der Karte abgebildet waren.
    Ziehen Sie mit der Maus die Elemente an ihre richtigen Positionen. Klicken Sie auf
    Neue Spielkarte für das nächste Spiel.
    `,
    },
  },
  {
    name: "bleistiftakrobatik",
    color: "#C9CA33",
    levels: 1,
    training: `Diese feinmotorische Aufgabe
    bringt Ihre Hirndurchblutung in
    Schwung. Zu Beginn, das heißt
    beim Verstehen und ersten
    Nachvollziehen der
    Übungsbeschreibung, kommt
    das Denken hinzu. Benutzen
    Sie nur noch Mittelfinger,
    Ringfinger und kleinen Finger,
    die meist weniger geübt sind,
    ist zusätzlich ein hohes Maß an
    Koordination gefordert.
    
    Bei Aufgabe 3 ist schnelles
    Reagieren gefragt.`,
    instruction: `Legen Sie einen Stift vor sich auf den Tisch. Lassen Sie diesen im Uhrzeigersinn
    kreisen unter Einsatz von Daumen, Zeigefinger und Mittelfinger einer Hand. Dabei
    "steigen" quasi Ihre Finger in schneller Folge nacheinander über den Stift und
    drehen ihn in die Bewegungsrichtung.
    
    Vollziehen Sie Bewegung so schnell wie möglich! Probieren Sie’s auch entgegen
    dem Uhrzeigersinn und mit der anderen Hand!`,
    overwriteInstructionAtLevel: {
      2: `Nehmen Sie einen Stift in eine Hand und drehen Sie ihn unter Einsatz von

    Daumen, Zeigefinger und Mittelfinger um seine Längsachse. Ändern Sie
    
    zwischendurch die Bewegungsrichtung mal zum Körper hin, mal vom Körper weg.
    
    Drehen Sie so schnell Sie können! Versuchen Sie es nacheinander mit beiden
    
    Händen.
    
    Variationen
    
    - Versuchen Sie die Übung mit einem Bleistift in jeder Hand
    
    - Benutzen Sie zum Drehen des Stiftes nur Zeige-, Mittel- und Ringfinger!
    Der Daumen sollte möglichst nicht helfen.
    
    - Lassen Sie den Stift beim Drehen um seine Längsachse wie im Slalom durch
    Ihre Finger laufen! Der Stift wird quasi durch die Finger "gewebt".
    `,
      3: `Halten Sie einen Stift mit einer Hand senkrecht wie ein Lot und halten Sie
    gleichzeitig die andere Hand ca. 20 bis 30 cm darunter auffangbereit. Lassen Sie
    den Stift senkrecht fallen und fangen Sie ihn mit der unteren Hand auf. Wechseln
    Sie die Fanghand - mal fängt die rechte, mal die linke Hand.
    
    Variationen:
    
    Gehen Sie genauso vor wie oben, aber die Fanghand fängt nur mit zwei Fingern,
    also Daumen und Zeigefinger, Daumen und Mittelfinger, Daumen und Ringfinger
    oder Daumen und kleinem Finger.`,
    },
    component: PenAcrobatics,
  },
  {
    name: "crossword",
    training: `Mit dieser Übung trainieren Sie
    Ihre Konzentration und die so
    genannte
    Informations-Verarbeitungs-Geschwindigkeit. Sie umfasst den
    Zeitraum, der erforderlich ist,
    um Informationen aus der
    Umwelt aufzunehmen, sie zu
    verarbeiten und darauf zu
    antworten. Aus der Fülle an
    Informationen, die überall und
    ständig auf uns einströmen
    müssen wir schnell die für uns
    wesentlichen herauszufiltern.
    Z.B. im Straßenverkehr, ist
    diese Fähigkeit in hohem Maße gefordert.`,
    color: "#B2B347",
    levels: 1,
    instruction: `Finden Sie im Raster das Wort SPORT, indem Sie aneinander grenzende Kästchen
    miteinander verbinden. Die gedachten Linien können gerade, schräg oder im
    Zickzack waagerecht oder senkrecht, aufwärts oder abwärts, links oder rechts
    beginnend verlaufen, das heißt in alle Leserichtungen. Es kommt nicht darauf an,
    ob die Buchstaben klein oder groß geschrieben sind - Sport, SPORT, sPorT, SPOrt,
    spORT usw. alles zählt als »Sport«.
    
    Markieren Sie die gefundenen Wörter durch Anklicken der einzelnen
    Buchstabenfelder. Die gefundenen Wörter werden dann farbig hervorgehoben.`,
    overwriteInstructionAtLevel: {
      2: `Finden Sie im Raster das Wort SPORT, indem Sie aneinander grenzende Kästchen
    miteinander verbinden. Die gedachten Linien können gerade, schräg oder im
    Zickzack waagerecht oder senkrecht, aufwärts oder abwärts, links oder rechts
    beginnend verlaufen, das heißt in alle Leserichtungen. Es kommt nicht darauf an,
    ob die Buchstaben klein oder groß geschrieben sind - Sport, SPORT, sPorT, SPOrt,
    spORT usw. alles zählt als »Sport«.
    
    Markieren Sie die gefundenen Wörter durch Anklicken der einzelnen
    Buchstabenfelder. Die gefundenen Wörter werden dann kurz farbig hervorgehoben. Die Markierung verschwindet anschließend wieder.
    `,
    },
    component: Crossword,
  },
  {
    name: "scramble",
    color: "#959351",
    levels: 1,
    training: `Bei dieser kombinierten Übung
    sind Kurzspeicher und
    Langzeitgedächtnis beteiligt.
    Sie müssen bekannte
    Buchstaben immer neu
    kombinieren, um zur Lösung zu
    kommen. Das Lösungswort ist
    im Langzeitgedächtnis
    abgelegt. So müssen immer
    neue Kombinationen mit
    gespeicherten
    Gedächtnisinhalten verglichen
    werden.
    
    Das bringt uns aus dem Trott,
    lässt uns Bekanntes in anderem
    Licht betrachten und offen für Neues bleiben.`,
    instruction: `Ordnen Sie die Buchstaben neu. Bei richtiger Zusammenstellung ergibt sich ein
    sinnvolles Wort. Ziehen Sie die Buchstaben zu diesem Zweck mit der Maus in das
    entsprechende Feld für das Lösungswort.
    
    Kleiner Tipp: Alle Begriffe drehen sich um den Sport. Beachten Sie: Umlaute
    wurden aufgelöst, das heißt Ä = AE,Ö = OE,Ü = UE,ß = SS.
    
    Überlegen Sie nicht zu lange. Dabei drehen sich nur die Gedanken im Kreis. Statt
    zu lange zu Grübeln, sollten Sie lieber mit einem Klick auf "Nächster Begriff" zur
    nächsten Aufgabe weiter gehen.`,
    component: Scramble,
  },
  {
    name: "fingerskilled",
    color: "#747566",
    levels: 3,
    component: FingerSkills,
    training: `Sie trainieren Feinmotorik und
    Feinkoordination im Sinn der
    sogenannten
    "Differenzierungsfähigkeit":
    Diese wird im Alltag auch als
    Bewegungsgefühl bezeichnet
    und hilft, Bewegungen bewusst
    zu steuern.
    
    Der Mausklick mit der freien
    Hand (mit der ungewohnten
    Hand für den Fall, dass die
    dominante Hand gerade in der
    Gebärde verharrt) stellt eine
    
    weitere Anforderung für das
    Gehirn dar.`,
    instruction: `Ahmen Sie die jeweils angezeigte Gebärde nach. Beginnen Sie mit der rechten Hand wie in der Abbildung. ÜBertragen Sie die Darstellung dann gegengleich auf die linke Hand.
    Haben Sie die Bewegung nachvollzogen, klicken sie auf Weiter, um zur nächsten Gebärde zu gelangen.`,
    overwriteInstructionAtLevel: {
      2: `Für wenige Sekunden wird Ihnen eine Gebärde angezeigt. Versuchen Sie, sich
      diese zu merken. Vollziehen Sie sie erst dann nach, wenn sie vom Bildschirm
      verschwunden ist und halten Sie die Hand in der entsprechenden Position.
      
      Nun klicken Sie auf »Kontrolle«, damit das Motiv noch einmal angezeigt wird und
      Sie Ihre Gebärde überprüfen können.
      
      Mit einem Klick auf »Weiter« geht's zur nächsten Gebärde.`,
      3: `Es wird Ihnen eine Folge von zwei oder mehr Gebärden gezeigt. Die Anzahl
      zwischen zwei und fünf Gebärden nacheinander können Sie frei wählen. Dabei ist
      jede einzelne Gebärde nur wenige Sekunden lang eingeblendet. Versuchen Sie,
      sich die Folge zu merken.
      
      Vollziehen Sie sie erst dann nach, wenn das letzte Motiv vom Bildschirm
      verschwunden ist. Nun klicken Sie auf "Kontrolle", damit die Motive noch einmal
      angezeigt werden und Sie Ihre Gebärde überprüfen können.
      
      Mit einem Klick auf »Weiter« geht's zur nächsten Gebärdenfolge.`,
    },
  },
  {
    name: "armsup",
    color: "#606054",
    levels: 1,
    training: `Sie üben hier Ihre
    Informations-Verarbeitungs-Geschwindigkeit und
    Reaktionsschnelligkeit. Die
    Pfeile tauchen auf den Karten
    bewusst in Kombination mit
    anderen Zeichen und an immer
    unterschiedlichen Stellen auf,
    um Ihr Gehirn von der
    gesuchten Information
    abzulenken. Im Alltag sind Sie
    ebenso gezwungen, die für Sie
    wichtigen Signale aus einer
    Vielzahl von Informationen um
    Sie herum herauszufiltern.
    `,
    instruction: `Es werden nach und nach Spielkarten gezeigt, auf denen unterschiedliche
    Informationen enthalten sind, verteilt auf fünf Felder. Konzentrieren Sie sich
    ausschließlich auf die Pfeile. Bringen Sie, sobald eine Karte erscheint, möglichst
    schnell Ihre beiden Arme gestreckt in die vom Pfeil angezeigte Richtung. Die
    Übung kann auch weniger bewegungsintensiv ausgeführt werden, indem Sie an
    Stelle der Arme nur die Unterarme oder nur die Daumen benutzen, um die
    Richtungsangabe nachzuvollziehen.
    `,
    overwriteInstructionAtLevel: {
      2: `Es werden nach und nach Spielkarten gezeigt, auf denen unterschiedliche
    Informationen enthalten sind, verteilt auf fünf Felder. Konzentrieren Sie sich
    ausschließlich auf die Pfeile. Ist der Pfeil blau oder rot, bringen Sie, sobald eine
    Karte erscheint, möglichst schnell Ihre beiden Arme gestreckt in die vom Pfeil
    angezeigte Richtung. Ist der Pfeil gelb oder grün, bewegen Sie Ihre Arme in die
    vom Pfeil entgegengesetzte Richtung.
    
    Variationen:
    
    Die Übung kann auch weniger bewegungsintensiv ausgeführt werden, indem Sie an
    Stelle der Arme nur die Unterarme oder nur die Daumen benutzen, um die
    Richtungsangabe nachzuvollziehen.`,
      3: `Es werden nach und nach Spielkarten gezeigt, auf denen unterschiedliche
  Informationen enthalten sind, verteilt auf fünf Felder. Konzentrieren Sie sich
  ausschließlich auf die Pfeile. Zeigt der Pfeil auf ein Zahlenfeld, so bringen Sie
  möglichst schnell Ihre beiden Arme in die vom Pfeil angezeigte Richtung. Deutet
  der Pfeil auf ein Buchstabenfeld, bewegen sich Ihre Arme in die dem Pfeil
  entgegengesetzte Richtung.
  
  Enthält das vom Pfeil angezeigte Feld ein Symbol oder einen geviertelten Kreis,
  so setzen Sie zusätzlich Ihre Sprache ein. Sie sprechen die Pfeilrichtung ("oben",
  "unten", etc). Ihre Arme bewegen sich dabei gleichzeitig in die dem Pfeil
  entgegengesetzte Richtung.`,
    },
    component: ArmsUp,
  },
];
